module.exports = __webpack_public_path__ + "img/bancode.89e742c.webp";